__turbopack_context__.v({
  "deliveryNotes": "DeliveryNotes-module-scss-module__8BnZmG__deliveryNotes",
  "text": "DeliveryNotes-module-scss-module__8BnZmG__text",
});
